import { defineEntity, number, object, foreign, entity, dateTime } from '~/prix'
import sql from '~/prix/utils/sql'

const courseRegisterIndividualEntity = defineEntity({
  key: 'courseRegisterIndividual',
  title: 'Registro de matriculas',
  sources: ['olap', 'oltp'],
  schema: object({
    id: number().label('ID', 'Identificador', 'Código'),
    courseProductId: foreign(entity('courseProduct').property('id')).label('Código do produto'),
    individualId: foreign(entity('individual').property('id')).label('Identificador pessoa física'),
    legalEntityId: foreign(entity('legalEntity').property('id')).label(
      'Identificador pessoa jurídica',
    ),
    registerDate: dateTime().label('Data do registro'),
    startDate: dateTime().label('Data de inicio'),
    endDate: dateTime().label('Data do fim'),
    courseCompletionPercentage: number().label('Porcentagem de conclusão do curso'),
    createdAt: dateTime().label('Data de criação'),
  }),
})

export const courseRegisterIndividualPropertyMap = {
  id: sql`course_register_individual.id`,
  courseProductId: sql`course_register_individual.course_product_id`,
  individualId: sql`course_register_individual.individual_id`,
  legalEntityId: sql`course_register_individual.legal_entity_id`,
  registerDate: sql`course_register_individual.register_date`,
  courseCompletionPercentage: sql`course_register_individual.course_completion_percentage`,
}

export default courseRegisterIndividualEntity
